<script setup>
import Logo from "@/components/Logo.vue";
import { useAppState } from '../stores/app-state';

const appState = useAppState();

function hideSidebar(){
    appState.menuOpen = false;
}

function handleLogOut(auth) {
    auth.logout();
    hideSidebar();
}
</script>

<template>
    <div class="sidebar" :class="[appState.menuOpen ? 'active' : '']">
        <Logo class="sidebar__logo"></Logo>

        <Transition mode="out-in">
            <div class="sidebar__nav" v-if="auth.authenticated">
                <router-link :to="{ path: '/' }" class="dash-link" @click="hideSidebar">
                    <svg-vue icon="home"></svg-vue><span>Dashboard</span>
                </router-link>
                <router-link :to="{ path: '/menus' }" class="dash-link" @click="hideSidebar">
                    <svg-vue icon="menus"></svg-vue><span>Menus</span>
                </router-link>
                <router-link :to="{ path: '/settings' }" class="dash-link" @click="hideSidebar">
                    <svg-vue icon="settings"></svg-vue><span>Settings</span>
                </router-link>
                <router-link :to="{ path: '/users' }" class="dash-link" @click="hideSidebar">
                    <svg-vue icon="users"></svg-vue><span>Users</span>
                </router-link>
            </div>
            <div class="sidebar__nav" v-else>
                <router-link :to="{ path: '/login' }" class="dash-link" @click="hideSidebar">
                    <svg-vue icon="login"></svg-vue><span>Login</span>
                </router-link>
            </div>
        </Transition>

        <div class="sidebar__bottom">

            <Transition>
                <div v-if="auth.authenticated && auth.user">
                    <div class="sidebar__user">
                        <img :src="auth.user.avatar_url" alt="profile picture" width="30">
                        <span>{{ auth.user.name }}</span>
                    </div>

                    <div class="sidebar__logout" @click="handleLogOut(auth)">
                        <svg-vue icon="login"></svg-vue><span>Log Out</span>
                    </div>
                </div>
            </Transition>

            <div class="developed-by">
                Developed by<br>
                <strong><a href="https://harrisoncarloss.com">Harrison Carloss</a></strong>
            </div>
        </div>
    </div>
</template>